module.exports = require('./er')(require './assertion-error')



// WEBPACK FOOTER //
// ./app/scripts/lib/assert/index.coffee